import {QrCodeLazy} from 'app/components/qrCode/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineQrCode(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-qr-code')) {
        return;
    }

    customElements.define(
        'gem-qr-code',
        class extends WebComponentLoader {
            reactLazyComponent = QrCodeLazy;
        },
    );
}
